import { Link } from "react-router"
import { useAuthUserDetails } from "@apis/users/useUsers"
import {
  Sidebar,
  SidebarContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
  useSidebar,
} from "@components/ui/sidebar"
import { getNavItems } from "./navItems"
import { NavMain } from "./NavMain"

export const AppSidebar = () => {
  const { data: userData } = useAuthUserDetails()
  const navItems = getNavItems(userData?.roles ?? [])
  const { setOpenMobile } = useSidebar()

  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <SidebarMenu className="tw:m-0 tw:p-0">
          <SidebarMenuItem>
            <SidebarMenuButton
              size="lg"
              asChild
              className="tw:hover:bg-transparent tw:hover:text-sidebar-foreground tw:active:bg-transparent tw:active:text-sidebar-foreground"
            >
              <Link
                to="/"
                onClick={() => setOpenMobile(false)}
                className="tw:text-sidebar-foreground tw:no-underline"
              >
                <div className="tw:flex tw:aspect-square tw:size-8 tw:items-center tw:justify-center tw:rounded-lg tw:bg-sidebar-primary">
                  <img
                    alt=""
                    className="tw:size-5"
                    src="/inspire_logo_white.png"
                  />
                </div>
                <span className="tw:text-base tw:font-semibold">Inspire</span>
              </Link>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <NavMain items={navItems} />
      </SidebarContent>
      <SidebarRail />
    </Sidebar>
  )
}
